import { BrowserMode } from '@/store/modules/entity_browser/config';

const routes = [
  {
    path: '/',
    name: 'DevHelp',
    component: () => import(/* webpackChunkName: "DevHelp" */ '../views/DevHelp.vue'),
  },
  {
    path: '/structure/tags',
    name: 'Tags',
    component: () => import(/* webpackChunkName: "Tags" */ '../views/Tags.vue'),
  },
  {
    path: '/document/saved_filters',
    name: 'Saved Search Filters',
    component: () => import(/* webpackChunkName: "SavedSearchFilters" */ '../views/doc_browser/SavedSearchFilters.vue'),
  },
  {
    path: '/document/browser',
    name: 'Document Browser',
    component: () => import(/* webpackChunkName: "DocumentBrowser" */ '../views/doc_browser/DocumentBrowser.vue'),
    props: {
      mode: BrowserMode.DOC,
    },
  },
  {
    path: '/document/media',
    name: 'Media Asset Management',
    component: () => import(/* webpackChunkName: "DocumentBrowser" */ '../views/doc_browser/DocumentBrowser.vue'),
    props: {
      mode: BrowserMode.MAM,
    },
  },
  // No menu page example
  {
    path: '/no_menu_example_page',
    name: 'No menu example page',
    component: () => import(/* webpackChunkName: "NoMenuPage" */ '../views/NoMenuPage.vue'),
  },

  {
    path: '/roles/user_files',
    name: 'User Files',
    component: () => import('@/components/roles/UserFilesPage.vue'),
  },

  // {
  //   path: '/',
  //   name: 'DevHelp',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
];

export default routes;
